import { api } from '@/api/client'
import type { PagedResult } from '@/types/api'
import type { Notification, NotificationPreference, UnreadCount } from '@/types/notifications'

export const notificationKeys = {
  all: ['notifications'] as const,
  list: (unreadOnly: boolean) => [...notificationKeys.all, 'list', unreadOnly] as const,
  unreadCount: () => [...notificationKeys.all, 'unread-count'] as const,
  preferences: () => [...notificationKeys.all, 'preferences'] as const,
}

export const notificationsApi = {
  list: (unreadOnly: boolean, pageSize = 20) =>
    api.get<PagedResult<Notification>>('/api/notifications', {
      query: { unreadOnly, pageSize },
    }),

  unreadCount: () => api.get<UnreadCount>('/api/notifications/unread-count'),

  /** Tom liste betyder alle ulæste. Svaret er det nye antal. */
  markRead: (notificationIds: string[] = []) =>
    api.post<UnreadCount>('/api/notifications/read', { notificationIds }),

  getPreferences: () => api.get<NotificationPreference[]>('/api/notifications/preferences'),

  savePreferences: (preferences: NotificationPreference[]) =>
    api.put<void>('/api/notifications/preferences', { preferences }),
}
